"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var daDKcountries = require("./da-DK/countries.json");
var daDKlocales = require("./da-DK/locales.json");
var daDKstarratings = require("./da-DK/star-ratings.json");
var deATcountries = require("./de-AT/countries.json");
var deATlocales = require("./de-AT/locales.json");
var deATstarratings = require("./de-AT/star-ratings.json");
var deCHcountries = require("./de-CH/countries.json");
var deCHlocales = require("./de-CH/locales.json");
var deCHstarratings = require("./de-CH/star-ratings.json");
var deDEcountries = require("./de-DE/countries.json");
var deDElocales = require("./de-DE/locales.json");
var deDEstarratings = require("./de-DE/star-ratings.json");
var enGBcountries = require("./en-GB/countries.json");
var enGBlocales = require("./en-GB/locales.json");
var enGBstarratings = require("./en-GB/star-ratings.json");
var enUScountries = require("./en-US/countries.json");
var enUSlocales = require("./en-US/locales.json");
var enUSstarratings = require("./en-US/star-ratings.json");
var esEScountries = require("./es-ES/countries.json");
var esESlocales = require("./es-ES/locales.json");
var esESstarratings = require("./es-ES/star-ratings.json");
var fiFIcountries = require("./fi-FI/countries.json");
var fiFIlocales = require("./fi-FI/locales.json");
var fiFIstarratings = require("./fi-FI/star-ratings.json");
var frBEcountries = require("./fr-BE/countries.json");
var frBElocales = require("./fr-BE/locales.json");
var frBEstarratings = require("./fr-BE/star-ratings.json");
var frFRcountries = require("./fr-FR/countries.json");
var frFRlocales = require("./fr-FR/locales.json");
var frFRstarratings = require("./fr-FR/star-ratings.json");
var itITcountries = require("./it-IT/countries.json");
var itITlocales = require("./it-IT/locales.json");
var itITstarratings = require("./it-IT/star-ratings.json");
var jaJPcountries = require("./ja-JP/countries.json");
var jaJPlocales = require("./ja-JP/locales.json");
var jaJPstarratings = require("./ja-JP/star-ratings.json");
var nbNOcountries = require("./nb-NO/countries.json");
var nbNOlocales = require("./nb-NO/locales.json");
var nbNOstarratings = require("./nb-NO/star-ratings.json");
var nlBEcountries = require("./nl-BE/countries.json");
var nlBElocales = require("./nl-BE/locales.json");
var nlBEstarratings = require("./nl-BE/star-ratings.json");
var nlNLcountries = require("./nl-NL/countries.json");
var nlNLlocales = require("./nl-NL/locales.json");
var nlNLstarratings = require("./nl-NL/star-ratings.json");
var plPLcountries = require("./pl-PL/countries.json");
var plPLlocales = require("./pl-PL/locales.json");
var plPLstarratings = require("./pl-PL/star-ratings.json");
var ptBRcountries = require("./pt-BR/countries.json");
var ptBRlocales = require("./pt-BR/locales.json");
var ptBRstarratings = require("./pt-BR/star-ratings.json");
var ptPTcountries = require("./pt-PT/countries.json");
var ptPTlocales = require("./pt-PT/locales.json");
var ptPTstarratings = require("./pt-PT/star-ratings.json");
var ruRUcountries = require("./ru-RU/countries.json");
var ruRUlocales = require("./ru-RU/locales.json");
var ruRUstarratings = require("./ru-RU/star-ratings.json");
var svSEcountries = require("./sv-SE/countries.json");
var svSElocales = require("./sv-SE/locales.json");
var svSEstarratings = require("./sv-SE/star-ratings.json");
var zhCNcountries = require("./zh-CN/countries.json");
var zhCNlocales = require("./zh-CN/locales.json");
var zhCNstarratings = require("./zh-CN/star-ratings.json");
exports.default = {
    'da-DK': {
        'countries': daDKcountries,
        'locales': daDKlocales,
        'star-ratings': daDKstarratings
    },
    'de-AT': {
        'countries': deATcountries,
        'locales': deATlocales,
        'star-ratings': deATstarratings
    },
    'de-CH': {
        'countries': deCHcountries,
        'locales': deCHlocales,
        'star-ratings': deCHstarratings
    },
    'de-DE': {
        'countries': deDEcountries,
        'locales': deDElocales,
        'star-ratings': deDEstarratings
    },
    'en-GB': {
        'countries': enGBcountries,
        'locales': enGBlocales,
        'star-ratings': enGBstarratings
    },
    'en-US': {
        'countries': enUScountries,
        'locales': enUSlocales,
        'star-ratings': enUSstarratings
    },
    'es-ES': {
        'countries': esEScountries,
        'locales': esESlocales,
        'star-ratings': esESstarratings
    },
    'fi-FI': {
        'countries': fiFIcountries,
        'locales': fiFIlocales,
        'star-ratings': fiFIstarratings
    },
    'fr-BE': {
        'countries': frBEcountries,
        'locales': frBElocales,
        'star-ratings': frBEstarratings
    },
    'fr-FR': {
        'countries': frFRcountries,
        'locales': frFRlocales,
        'star-ratings': frFRstarratings
    },
    'it-IT': {
        'countries': itITcountries,
        'locales': itITlocales,
        'star-ratings': itITstarratings
    },
    'ja-JP': {
        'countries': jaJPcountries,
        'locales': jaJPlocales,
        'star-ratings': jaJPstarratings
    },
    'nb-NO': {
        'countries': nbNOcountries,
        'locales': nbNOlocales,
        'star-ratings': nbNOstarratings
    },
    'nl-BE': {
        'countries': nlBEcountries,
        'locales': nlBElocales,
        'star-ratings': nlBEstarratings
    },
    'nl-NL': {
        'countries': nlNLcountries,
        'locales': nlNLlocales,
        'star-ratings': nlNLstarratings
    },
    'pl-PL': {
        'countries': plPLcountries,
        'locales': plPLlocales,
        'star-ratings': plPLstarratings
    },
    'pt-BR': {
        'countries': ptBRcountries,
        'locales': ptBRlocales,
        'star-ratings': ptBRstarratings
    },
    'pt-PT': {
        'countries': ptPTcountries,
        'locales': ptPTlocales,
        'star-ratings': ptPTstarratings
    },
    'ru-RU': {
        'countries': ruRUcountries,
        'locales': ruRUlocales,
        'star-ratings': ruRUstarratings
    },
    'sv-SE': {
        'countries': svSEcountries,
        'locales': svSElocales,
        'star-ratings': svSEstarratings
    },
    'zh-CN': {
        'countries': zhCNcountries,
        'locales': zhCNlocales,
        'star-ratings': zhCNstarratings
    }
};
